import IMotorista from 'modules/motorista/domain/entities/IMotorista'

import IFindFavorecidosTmovPayRequest from '../entities/IFindFavorecidosTmovPayRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IFindFavorecidosTmovPay {
  execute(params: IFindFavorecidosTmovPayRequest): Promise<IMotorista[]>
}

export default class FindFavorecidosTmovPayImpl
  implements IFindFavorecidosTmovPay
{
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}
  async execute(params: IFindFavorecidosTmovPayRequest): Promise<IMotorista[]> {
    const response = await this.pagamentoRepository.findFavorecidosTmovPay(
      params,
    )
    return response
  }
}
